<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-situacao') {
            next({ name: 'ven-situacao-list' });
        } else if (to.name == 'agro-situacao') {
            next({ name: 'agro-situacao-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-situacao') {
            this.$router.push({ name: 'ven-situacao-list' });
        } else if (this.$route.name == 'agro-situacao') {
            this.$router.push({ name: 'agro-situacao-list' });
        }
    },
};
</script>
